export const ITEMS = {
    DISABLED: 'DISABLED',
    ENABLED: 'ENABLED',
    IMMEDIATELY: 'IMMEDIATELY',
}

export const INTERVAL_OPTIONS = [3, 10, 30]
